/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CouponPayItem
 */
export interface CouponPayItem {
    /**
     * 优惠券ID
     * @type {number}
     * @memberof CouponPayItem
     */
    couponId?: number;
    /**
     * 数量
     * @type {number}
     * @memberof CouponPayItem
     */
    quantity?: number;
    /**
     * 优惠券金额
     * @type {number}
     * @memberof CouponPayItem
     */
    amount?: number;
}

/**
 * Check if a given object implements the CouponPayItem interface.
 */
export function instanceOfCouponPayItem(value: object): value is CouponPayItem {
    return true;
}

export function CouponPayItemFromJSON(json: any): CouponPayItem {
    return CouponPayItemFromJSONTyped(json, false);
}

export function CouponPayItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): CouponPayItem {
    if (json == null) {
        return json;
    }
    return {
        
        'couponId': json['couponId'] == null ? undefined : json['couponId'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function CouponPayItemToJSON(json: any): CouponPayItem {
    return CouponPayItemToJSONTyped(json, false);
}

export function CouponPayItemToJSONTyped(value?: CouponPayItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'couponId': value['couponId'],
        'quantity': value['quantity'],
        'amount': value['amount'],
    };
}

